import { defineComponent as e, openBlock as t, createBlock as o, withCtx as r, createVNode as n, unref as a } from "vue";
import { RevSkeleton as m } from "@ds/components/Skeleton";
import c from "./DocumentSmallBase.vue2.js";
const d = /* @__PURE__ */ e({
  name: "DocumentLoadingSmall",
  __name: "DocumentLoadingSmall",
  setup(i) {
    return (l, p) => (t(), o(c, { class: "grid place-items-center" }, {
      default: r(() => [
        n(a(m), {
          height: "2.5rem",
          shape: "rectangle",
          width: "2.5rem"
        })
      ]),
      _: 1
    }));
  }
});
export {
  d as default
};
